import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

/*Sign in template in : https://github.com/mui-org/material-ui/blob/master/docs/src/pages/getting-started/page-layout-examples/sign-in/SignIn.js */
// import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import IpmIcon from '../../images/transparent.png';





//Redirect page if login
import { Redirect } from 'react-router-dom';

//Alerta
import Alerta from '../common/Alerta';


/*Styling */
const styles = theme => ({
  "@global":{
    body:{
      backgroundColor:"#243043"
    }
  },
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 21,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    backgroundColor:"#2B3648",
    margin:0,
    width:90,
    height:90,
    minWidth:90, 
    minHeight:90
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
   myinput: {
     root:{
        '& label.Mui-focused': {
        color: 'green',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: 'green',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'red',
        },
        '&:hover fieldset': {
          borderColor: 'yellow',
        },
        '&.Mui-focused fieldset': {
          borderColor: 'green',
        },
      },
     }
  },
});

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'red',
      },
      '&:hover fieldset': {
        borderColor: 'yellow',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'green',
      },
    },
  },
})(TextField);

export class LoginAdmin extends Component {
  static propTypes = {
    login: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      usuario: { username: '', password: '' },
      showPassword: false,
      errores: {},
      formValid: false,
      openAlert:false
    };
    this.handleChange = this.handleChange.bind(this);
  }


  doLogin = () =>{
    this.props.actions.doLogin(this.state.usuario).then(()=> {
     if(this.props.logged === true){
        this.cleanInfo();
        this.props.actions.fetchPermisos();
      }
    }).catch(() => {
      this.sendError();
    });
  }

  sendError =()=>{
    this.setState({openAlert:true}); 
    this.cleanInfo();
  }
  
  cleanInfo = () => {
    let usuario = this.state.usuario;
    usuario.password = '';
    usuario.username = '';
    this.setState({
      usuario: usuario,
      errores: {},
      formValid:false
    });
  };

   handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let usuario = this.state.usuario;
    usuario[name] = value;
    this.setState({
      usuario: usuario,
    });
    this.validateForm();
  }

  validateForm = () => {
    let errores = {};
    let formValid = true;
    if (!this.state.usuario || !this.state.usuario.username || this.state.usuario.username.length < 1) {
      errores.message = 'You must introduce a valid credentials';
      formValid = false;
    }
    if (
      !this.state.usuario ||
      !this.state.usuario.password ||
      this.state.usuario.password.length < 1
    ) {
      errores.message = 'You must introduce a valid credentials';
      formValid = false;
    }
    this.setState({
      errores: errores,
      formValid: formValid,
    });
  };

  closeErrorDialog = ()=>{
    this.setState({openAlert:false});
  }

  sendToPasswordReset= ()=>{
    this.props.history.push('/login/resetPassword');
  }

  render() {
    const { classes } = this.props;
    return (
      <main className={classes.main} >
      {localStorage.getItem("logged") ? (
         <Redirect
           push
           to={
             '/'
           }
         />
       ):null}
       <div >
         <CssBaseline />
         <Paper className={classes.paper}>
             <div style={{backgroundColor:"#a0a0a0"}}>
             <div className={classes.avatar}  style={{marginBottom:'0%',maxHeight:40,/* minWidth:80, minHeight:80,*/ borderRadius:0}} variant="square">
               <img src={IpmIcon} style={{marginLeft:"20px", marginTop:"10px"}} width="50px" height="70px" alt="logo"></img>
             </div>
             </div>
             <Typography component="h1" variant="h5" style={{color:"#5a6271", marginTop:"15px", marginBottom:"-5px"}}>
               Sign in
             </Typography>
           <form className={classes.form}>
             <FormControl margin="normal" required fullWidth className={classes.myroot}>
               <CssTextField
                 label="Username"
                 variant="outlined"
                  id="username" name="username" autoComplete="username" autoFocus 
                 value={this.state.usuario.username ? this.state.usuario.username : ''}
                 error={this.state.errores.username ? true : false}
                 onChange={this.handleChange} 
               />
             </FormControl>
             <FormControl margin="normal" required fullWidth className={classes.myroot}>
               <CssTextField
                 heap-ignore='true'
                 label="Password"
                 variant="outlined"
                 name="password" type="password" id="password" autoComplete="current-password" 
                 value={this.state.usuario.password ? this.state.usuario.password : ''}
                 onChange={this.handleChange}
                 error={this.state.errores.password ? true : false}
                 onKeyPress={e => {
                   if (e.key === 'Enter') {
                     this.doLogin();
                   }
                 }} 
                 style={{borderColor:"red !important", color:"red"}}
               />
             </FormControl>
             <br/>
             <span style={{color:"red", fontSize:"0.8em"}}>{this.state.errores.message}</span>
             <Button
               fullWidth
               variant="contained"
               color="primary"
               className={classes.submit}
               onClick={this.doLogin}
               disabled={!this.state.formValid}
             >
               Sign in
             </Button>
           </form>
         </Paper>
       </div>
       <Alerta message={"The user and/or password are wrong."} openAlert={this.state.openAlert} closeErrorDialog={this.closeErrorDialog}/>
     </main>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(LoginAdmin));



// WEBPACK FOOTER //
// ./src/features/login/LoginAdmin.js